import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CompetitionService } from 'src/app/+competitions/services/competition.service';
import { Competition } from 'src/app/+shared/model/interfaces/competition';
import { LotteryService } from 'src/app/services';
import { ClientService } from 'src/app/services/client.service';
import * as internal from 'stream';
import { HeroSchedule } from './heroSchedule';

@Component(
    {
        templateUrl: './home.component.html',
        selector: 'app-home',
        styleUrls: ['./home.component.scss']
    }
)
export class HomeComponent implements OnInit, OnDestroy  
{
  public saleStop: any = {};
  public saleStopDate: Date;
  public hovered3_2 = false;
  public hovered1_1 = false;
  public hovered1_2 = false;
  public hovered1_4 = false;
  public hovered1_8 = true;
  public mobileView: boolean;
  public headerTextPrimary = false;

  // TODO: Avoid cross reference by moving interface to this module
  public allCompetitions: Competition[];

  private router: Router;
  private readonly lotteryService: LotteryService;
  private readonly competitionService: CompetitionService;
  private readonly clientService: ClientService
  private competitionsSubscription: Subscription;

  public heroType: number;

  private heroScheduling: HeroSchedule[] = [
    /* real data 
      0: winner
      1: kort
      2: tvc
      3: 7-days countdown
      4: christmas
      5: calender
      6: new-year-eve
    */

    {
      heroType: 1,
      fromDate: new Date("2022-09-23T00:00:00"),
      toData: new Date("2022-09-29T00:00:00")
    },
    {
      heroType: 2,
      fromDate: new Date("2022-09-29T00:00:01"),
      toData: new Date("2022-10-02T00:00:00")
    },
    {
      heroType: 5, 
      fromDate: new Date("2022-10-02T00:00:01"),
      toData: new Date("2022-10-07T00:00:00")
    },
    {
      heroType: 3, 
      fromDate: new Date("2022-10-07T00:00:01"),
      toData: new Date("2022-10-14T10:30:00")
    },  
    {
      heroType: 5,
      fromDate: new Date("2023-10-14T10:30:01"),
      toData: new Date("2023-10-28T00:00:00")
    }, 
    {
      heroType: 2, 
      fromDate: new Date("2022-10-28T00:00:01"),
      toData: new Date("2022-11-07T00:00:00")
    },
    {
      heroType: 3, 
      fromDate: new Date("2022-11-07T00:00:01"),
      toData: new Date("2022-11-14T10:30:00")
    },
    {
      heroType: 0, 
      fromDate: new Date("2022-11-14T10:30:00"),
      toData: new Date("2022-11-17T00:00:00")
    },
    {
      heroType: 4, /*jul-hero*/ 
      fromDate: new Date("2022-11-17T00:00:01"),
      toData: new Date("2022-12-07T00:00:00")
    },
    {
      heroType: 3, 
      fromDate: new Date("2022-12-07T00:00:01"),
      toData: new Date("2022-12-14T10:30:00")
    },
    {
      heroType: 4, /*jul-hero*/ 
      fromDate: new Date("2022-12-14T10:30:01"),
      toData: new Date("2022-12-25T00:00:00")
    },
    {
      heroType: 2, 
      fromDate: new Date("2022-12-25T00:00:01"),
      toData: new Date("2022-12-28T00:00:00")
    },
    {
      heroType: 6, /*old new-year-hero*/ 
      fromDate: new Date("2022-12-28T00:00:01"),
      toData: new Date("2023-01-04T00:00:00")
    },
    {
      heroType: 2,
      fromDate: new Date("2023-01-04T00:00:01"),
      toData: new Date("2023-01-06T00:00:00")
    },
    {
      heroType: 3, 
      fromDate: new Date("2023-01-06T00:00:01"),
      toData: new Date("2023-01-13T10:30:00")
    },
    {
      heroType: 0, 
      fromDate: new Date("2023-01-13T10:30:01"),
      toData: new Date("2023-01-20T00:00:00")
    },
    {
      heroType: 1, 
      fromDate: new Date("2023-01-20T00:00:01"),
      toData: new Date("2023-01-29T00:00:00")
    },
    {
      heroType: 2, 
      fromDate: new Date("2023-01-29T00:00:01"),
      toData: new Date("2023-02-04T00:00:00")
    },
    {
      heroType: 1, 
      fromDate: new Date("2023-02-04T00:00:01"),
      toData: new Date("2023-02-07T00:00:00")
    },
    {
      heroType: 3, 
      fromDate: new Date("2023-02-07T00:00:01"),
      toData: new Date("2023-02-13T10:30:00")
    },
    {
      heroType: 0, 
      fromDate: new Date("2023-02-13T10:30:01"),
      toData: new Date("2023-02-20T00:00:00")
    },
    {
      heroType: 5, /*missing updated grafic*/ 
      fromDate: new Date("2023-02-20T00:00:01"),
      toData: new Date("2023-02-26T00:00:00")
    },
    {
      heroType: 2,
      fromDate: new Date("2023-02-26T00:00:01"),
      toData: new Date("2023-02-29T00:00:00")
    },




    /*  test data*/
    // {
    //   heroType: 3,
    //   fromDate: new Date("2022-10-14T10:30:01"),
    //   toData: new Date("2022-12-28T00:00:00")
    // },
    
    // {
    //   heroType: 5,
    //   fromDate: new Date("2022-09-16T15:03:00"),
    //   toData: new Date("2022-10-16T15:04:00")
    // }
    // ,
    // {
    //   heroType: 6,
    //   fromDate: new Date("2022-09-16T15:04:00"),
    //   toData: new Date("2022-09-16T15:15:00")
    // }
  ] 


  constructor( 
    router: Router, 
    lotteryService: LotteryService,
    competitionService: CompetitionService,
    clientService: ClientService
  ) { 
    this.router = router;
    this.lotteryService = lotteryService;
    this.competitionService = competitionService;
    this.clientService = clientService;
  }

  public ngOnInit(): void 
  {
    this.findCurrentHero();
    this.getCurrentCompetitions();
    this.mobileView = this.clientService.checkForMobileView();
  }

  private findCurrentHero(): void
  {

    const nowMillis = new Date().getTime();
    const activeHeroArray = this.heroScheduling.filter(item =>
      {
          const fromDateMillis = item.fromDate.getTime();
          const toDateMillis = item.toData.getTime();

          return (fromDateMillis < nowMillis) && (nowMillis < toDateMillis);
      });

    if(activeHeroArray.length)
    {
      this.heroType = activeHeroArray[0].heroType;
    }
    else{
      // default countdown
      this.heroType = 0;
    }
  }




  public showPage(path: string): void
  {
    this.router.navigateByUrl(path);
  }
  
  public onSignUpExternalClick(url: string): void
  {
      window.document.location.href = url;
  }


  private getCurrentCompetitions(): void
  {
    this.competitionsSubscription = this.competitionService.getCurrentCompetitions().subscribe(
        (competititons) =>
        {
            const sortedCompetitions = competititons.sort((a, b) =>
            {
                return a.ExternalCompetitionUrl.length - b.ExternalCompetitionUrl.length;
            });

            if(sortedCompetitions.length > 0)
            {
              this.allCompetitions = [sortedCompetitions[0]];
            }
            else 
            {
              this.allCompetitions = [];
            }

       
         }
    );
  }

  public ngOnDestroy(): void
  {
      if (this.competitionsSubscription)
      {
          this.competitionsSubscription.unsubscribe();
      }
  }
}
